import liveMapReducer from './liveMapReducer';

export default liveMapReducer;
